// src/components/common/InstitutionProfile.js
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getInstitutionApi } from "../../apiservice/setting";
import { FRONTEND_APP_URL } from "../../environment";
import Swal from "sweetalert2";
import { selectAuthInfo } from "../../pages/Auth/authSelectors";

const InstitutionProfile = () => {
  const authInfo = useSelector(selectAuthInfo);
  const [institution, setInstitution] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await getInstitutionApi();
        if (res === "Error: Request failed with status code 401") {
          sessionStorage.clear();
          window.location.href = FRONTEND_APP_URL;
          return;
        }
        setInstitution(res.data);
      } catch (err) {
        Swal.fire({
          icon: "warning",
          title:
            err.response?.data?.message ||
            "Internal Error: If the issue persists, please contact support.",
          confirmButtonColor: "#1677ff",
        });
      }
    };

    fetchProfile();
  }, []);

  // --- Decide logo
  const logoUrl = authInfo?.branch_info
    ? institution?.branch_logo
    : institution?.logo;

  // --- Decide name
  const name =
    (authInfo?.branch_info
      ? institution?.branch_name
      : institution?.name) ||
    authInfo?.userInfo?.branch_name ||
    authInfo?.userInfo?.full_name ||
    "Institution";

  // --- Decide description
  const description =
    (authInfo?.branch_info
      ? institution?.branch_description
      : institution?.description) || null;

  return (
  <div className="institution-header">
    {/* LEFT: Logo */}
    <div className="institution-logo">
      {logoUrl ? (
        <img src={logoUrl} alt={name} />
      ) : (
        <div className="logo-placeholder">No Logo</div>
      )}
    </div>

    {/* CENTER: Company text */}
    <div className="institution-text">
      <h2>{name}</h2>
      {description && <p>{description}</p>}
    </div>

    {/* RIGHT: empty spacer for symmetry */}
    <div className="institution-spacer" />
  </div>
);

};

export default InstitutionProfile;
